import { Address, LabelValue, Image } from '../../../shared/shared.interface';
import { KngButtonState } from '../../button';

export interface KngMydealer {
    state: KngMydealerState;
}
export interface KngMydealerState {
   myDealer: MyDealer;
   isButton: boolean;
   button?: KngButtonState;
   url: string;
   page? : string;
   isError?: boolean;
   loading?: boolean;
   noResult?: {
      label: string;
      text?: string;
      iconPath: string;
      altText?: string;
    };
}
export interface MyDealer {
    firstName: string;
    lastName: string;
    phone: LabelValue;
    email: LabelValue;
    address: AddressState;
 }
export interface AddressState {
    label: string;
    value: Address;
    icon?: Image;
 }

